"use strict";

import Swiper from 'swiper';
import { FreeMode } from 'swiper/modules';
import { withCarouselNav, syncCarouselNavVisibility } from './carousel-nav';

const SELECTOR = '[data-flexcontent-columns-carousel]';
const GAP_REM = 1.5;

function getGap() {
	return parseFloat(getComputedStyle(document.documentElement).fontSize) * GAP_REM;
}

function initFlexcontentColumnsCarousel() {
	const spaceBetween = getGap();

	document.querySelectorAll(SELECTOR).forEach(function (el) {
		if (el.swiper) {
			return;
		}

		const swiper = new Swiper(el, withCarouselNav(el, {
			modules: [FreeMode],
			slidesPerView: 1.15,
			spaceBetween,
			grabCursor: true,
			freeMode: {
				enabled: true,
				momentumRatio: 0.85,
				momentumVelocityRatio: 0.85,
			},
			breakpoints: {
				768: {
					slidesPerView: 2.2,
				},
				992: {
					slidesPerView: 3,
				},
			},
		}));

		syncCarouselNavVisibility(swiper);
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initFlexcontentColumnsCarousel, { once: true });
} else {
	initFlexcontentColumnsCarousel();
}
